export const RedFlagIndicator = ({ isRedFlag }) => {
  return (
    <div className="rf-indicator-container">
      <div
        className={`rf-indicator-circle ${
          isRedFlag ? "rf-indicator-active" : ""
        }`}
      >
        {isRedFlag ? (
          <>
            <div className="rf-indicator-inner-dot" />
            <div className="rf-indicator-outer-ring" />
          </>
        ) : null}
      </div>
    </div>
  );
};
